import Icon from '../components/Icon.vue'

Icon.register({
  'arrow-left': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0l-194.4-194.3c-9.4-9.4-9.4-24.6 0-33.9l194.4-194.4c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-0.4 34.3l-120.5 114.8h287.4c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24h-287.4l120.5 114.8c9.8 9.3 10 24.8 0.4 34.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-left.js
// module id = 621
// module chunks = 0